// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* From Uiverse.io by Chriskoziol */ 
.spinnerContainer {
    margin: 100px auto 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    direction: ltr;
}

.spinner {
    width: 150px;
    height: 150px;
    display: grid;
    border: 7px solid #0000;
    border-radius: 50%;
    border-right-color: #299fff;
    animation: tri-spinner 2s infinite linear;
}

.spinner::before,
.spinner::after {
  content: "";
  grid-area: 1/1;
  margin: 18px;
  border: inherit;
  border-radius: 50%;
  animation: tri-spinner 4s infinite;
}

.spinner::after {
  margin: 6px;
  animation-duration: 6s;
}

@keyframes tri-spinner {
  100% {
    transform: rotate(1turn);
  }
}

.loader {
    color: #4a4a4a;
    font-family: "Poppins",sans-serif;
    font-weight: 500;
    font-size: 55px;
    box-sizing: content-box;
    height: 55px;
    padding: 5px 5px;
    display: flex;
    border-radius: 8px;
}

.spinnerP{
    margin: 0;
}

.words {
  overflow: hidden;
}

.word {
  display: block;
  height: 100%;
  padding-left: 6px;
  color: #299fff;
  animation: cycle-words 5s infinite;
}

@keyframes cycle-words {
  10% {
    transform: translateY(-105%);
  }

  25% {
    transform: translateY(-100%);
  }

  35% {
    transform: translateY(-205%);
  }

  50% {
    transform: translateY(-200%);
  }

  60% {
    transform: translateY(-305%);
  }

  75% {
    transform: translateY(-300%);
  }

  85% {
    transform: translateY(-405%);
  }

  100% {
    transform: translateY(-400%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/style/loading.css"],"names":[],"mappings":"AAAA,mCAAmC;AACnC;IACI,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;IACI,cAAc;IACd,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;IAEf,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAGhB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE;IAEE,4BAA4B;EAC9B;;EAEA;IAEE,4BAA4B;EAC9B;;EAEA;IAEE,4BAA4B;EAC9B;;EAEA;IAEE,4BAA4B;EAC9B;;EAEA;IAEE,4BAA4B;EAC9B;;EAEA;IAEE,4BAA4B;EAC9B;;EAEA;IAEE,4BAA4B;EAC9B;;EAEA;IAEE,4BAA4B;EAC9B;AACF","sourcesContent":["/* From Uiverse.io by Chriskoziol */ \n.spinnerContainer {\n    margin: 100px auto 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    direction: ltr;\n}\n\n.spinner {\n    width: 150px;\n    height: 150px;\n    display: grid;\n    border: 7px solid #0000;\n    border-radius: 50%;\n    border-right-color: #299fff;\n    animation: tri-spinner 2s infinite linear;\n}\n\n.spinner::before,\n.spinner::after {\n  content: \"\";\n  grid-area: 1/1;\n  margin: 18px;\n  border: inherit;\n  border-radius: 50%;\n  animation: tri-spinner 4s infinite;\n}\n\n.spinner::after {\n  margin: 6px;\n  animation-duration: 6s;\n}\n\n@keyframes tri-spinner {\n  100% {\n    transform: rotate(1turn);\n  }\n}\n\n.loader {\n    color: #4a4a4a;\n    font-family: \"Poppins\",sans-serif;\n    font-weight: 500;\n    font-size: 55px;\n    -webkit-box-sizing: content-box;\n    box-sizing: content-box;\n    height: 55px;\n    padding: 5px 5px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    border-radius: 8px;\n}\n\n.spinnerP{\n    margin: 0;\n}\n\n.words {\n  overflow: hidden;\n}\n\n.word {\n  display: block;\n  height: 100%;\n  padding-left: 6px;\n  color: #299fff;\n  animation: cycle-words 5s infinite;\n}\n\n@keyframes cycle-words {\n  10% {\n    -webkit-transform: translateY(-105%);\n    transform: translateY(-105%);\n  }\n\n  25% {\n    -webkit-transform: translateY(-100%);\n    transform: translateY(-100%);\n  }\n\n  35% {\n    -webkit-transform: translateY(-205%);\n    transform: translateY(-205%);\n  }\n\n  50% {\n    -webkit-transform: translateY(-200%);\n    transform: translateY(-200%);\n  }\n\n  60% {\n    -webkit-transform: translateY(-305%);\n    transform: translateY(-305%);\n  }\n\n  75% {\n    -webkit-transform: translateY(-300%);\n    transform: translateY(-300%);\n  }\n\n  85% {\n    -webkit-transform: translateY(-405%);\n    transform: translateY(-405%);\n  }\n\n  100% {\n    -webkit-transform: translateY(-400%);\n    transform: translateY(-400%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
